// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__g1hx5","label":"Radio_label__BvlSZ","checkMark":"Radio_checkMark__AuENV","disabled":"Radio_disabled__2qxi7"};